import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HarshEvent } from '../class/HarshEvent';
import { ApiService } from './api.service';
import { BaseService } from './base.service';
import { AuthService } from './auth.service';
import { HarshEventStateService } from './harshevent-state.service';
import { MapService } from './map.service';

interface LoadArgs {
  type: string;
  uid: number;
  range: {
    from: number;
    to: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class HarshEventService extends BaseService<Record<number, HarshEvent>> {
  private _dataType: 'harsheventtrip' | 'harsheventdrivertrip';

  private _authService = inject(AuthService);
  private _mapService = inject(MapService);
  private _harshEventStateService = inject(HarshEventStateService);

  constructor() {
    super(inject(ApiService));
  }

  public override HandleResponse(response: JSON): Record<number, HarshEvent> {
    const resp = response[this._dataType]['data'];
    const datas: Record<number, HarshEvent> = this._harshEventStateService.$harshEvents() || {};

    for (const harshBack of Object.values(resp) as HarshEvent[]) {
      datas[harshBack.uid] = new HarshEvent(harshBack);
    }
    return datas;
  }

  public async loadEvent(args: LoadArgs): Promise<Record<number, HarshEvent>> {
    this._dataType = args.type === 'trip' ? 'harsheventtrip' : 'harsheventdrivertrip';
    this._harshEventStateService.setHarshEvents({});
    this._mapService.removePopups();

    try {
      const events = await lastValueFrom(this.Get(this._dataType, this._getParams(args)));
      this._harshEventStateService.updateHarshEvents(current => Object.assign(current, events));
      return events;
    } catch (error) {
      console.log(error);
      throw new Error('not a good response', { cause: error });
    }
  }

  public clear(): void {
    this._harshEventStateService.clear();
  }

  private _getParams({ type, uid, range }: LoadArgs): object {
    const token = this._authService.$token();
    return type === 'trip'
      ? { token, from: range.from, to: range.to, uid_device: uid }
      : { token, from: range.from, to: range.to, uid_driver: uid };
  }
}
